import { envVar } from '@env'
import { User } from '@features/auth/auth-client-adapter'
import { AnalyticsEvent } from '../analytics-events'
import { AnalyticsProvider, EventData } from '../core'
import { Effect } from 'effect'

declare global {
  interface Window {
    dataLayer?: object[]
  }
}

function push(obj: object) {
  if (typeof window == 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(obj)
}

const CONVERSION_EVENTS: Record<string, string> = {
  signed_up: 'AW-10829380399/LJv9COvSzY0DEK_27Kso'
}

function ensureInstalled() {
  const containerId = envVar('NEXT_PUBLIC_GTM_CONTAINER_ID')
  if (!containerId) return

  if (typeof document == 'undefined') return
  if (document.getElementById('gtm')) return

  push({ 'gtm.start': Date.now(), 'event': 'gtm.js' })

  const s = document.createElement('script')
  s.id = 'gtm'
  s.async = true
  s.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`
  document.head.appendChild(s)
}

export const GoogleTagManagerService: AnalyticsProvider = {
  trackUserIdentified(user: User) {
    return Effect.sync(() => {
      ensureInstalled()
      push({ event: 'user_identified', user_id: user.id })
    })
  },
  trackUserAnonymous() {
    return Effect.sync(() => {
      ensureInstalled()
      push({ event: 'user_signed_out', user_id: null })
    })
  },
  track(event: AnalyticsEvent, data: EventData = {}) {
    return Effect.sync(() => {
      ensureInstalled()
      push({ event, ...data })
      const conversionEvent = CONVERSION_EVENTS[event]
      if (conversionEvent) {
        push({ event: 'conversion', send_to: conversionEvent })
      }
    })
  },
  trackLocationChanged(location: string) {
    return Effect.sync(() => {
      ensureInstalled()
      if (typeof document == 'undefined') return
      push({ event: 'page_view', page_title: document.title, page_path: location })
    })
  }
}
